<template>
    <div>
        <div class="main">

            <!-- 資料讀取中 -->
            <div id="mask" class="hide">
                <div class="text">
                    <i class="fas fa-spinner fa-pulse"></i> 資料讀取中
                </div>
            </div>

            <!-- 標題列 -->
            <div class="main-title">
                <b-row align-h="between">
                    <!-- 標題 -->
                    <b-col cols="auto"><h2 class="px-3">{{ title }}</h2></b-col>
                    <!-- 導覽列 -->
                    <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>       
                </b-row>
            </div>
            <!-- (未登入) -->
            <div class="main-content" v-show="false">

                <div class="w3-container w3-display-container" v-show="!checkLogin()">
                    <div class="w3-row title-chart">此功能需要登入才能使用，請點按鈕前往登入頁面</div>
                    <div class="w3-container w3-center">
                        <img src="static/img/img_avatar.png" alt="Avatar" style="width:300px">
                        <div class="w3-row title-chart">訪客(未登入)</div>

                        <div class="w3-section">
                            <button class="w3-button w3-green w3-round-large" style="width:300px" @click="goLogin">前往登入</button>
                        </div>
                    </div>
                </div>

            </div>
            <!-- (已登入) -->
            <div class="main-content" v-show="true">

                <!-- 步驟1 --> 
                <div class="w3-container w3-display-container w3-teal py-4">
                    <b-container>
                        <!-- 標題 -->
                        <h5 class="title-sub">{{ setp.title }}</h5>
                        <!-- 條件選單 -->
                        <div class="w3-row">
                            <!-- 種類 -->
                            <div class="w3-col w3-container m4 l3">
                                <p>
                                    <label style="color: #FFFFFF">{{ setp.type.text }}</label>
                                    <select class="w3-select" v-model="setp.type.value">
                                        <option value="-1">{{ setp.type.placeholder }}</option>
                                        <option v-for="(value, key) in setp.type.list" :value="key" :key="'type' + key" >{{ value.text }}</option>
                                    </select>
                                </p>
                            </div>
                            <!-- 市場作物名稱 -->
                            <div class="w3-col w3-container m4 l3">
                                <p>
                                    <label style="color: #FFFFFF">{{ setp.market_crop.text }}</label>
                                    <select class="w3-select" v-model="setp.market_crop.value">
                                        <!--
                                        <option value="-1">{{ setp.market_crop.placeholder }}</option>
                                        <option v-for="(value, key) in setp.market_crop.list" :value="key" :key="'type' + key" >{{ value.text }}</option>
                                        -->
                                        <option value="-1">{{ setp.market_crop.placeholder }}</option>
                                        <optgroup v-for="(value, key) in setp.market_crop.group" :label="value.label" :key="'crop' + key">
                                            <option v-for="(value2, key2) in value.list" :value="value2.value" :key="'crop' + key2" >{{ value2.text }}</option>
                                        </optgroup>
                                    </select>
                                </p>
                            </div>
                            <!-- 預留空白 -->
                            <div class="w3-col w3-container m4 l3">
                                &nbsp;
                            </div>
                            <!-- 完成第1步驟 -->
                            <div class="w3-col w3-container m4 l3" v-if="setp.market_crop.value != '-1'">
                                <p>
                                    <i class="fas fa-check check"></i><span class="check-text">您已成功完成第一步驟。</span>
                                </p>
                                <p>
                                    <i class="fas fa-angle-double-down faa-bounce faa-reverse double-down"></i><span class="double-down-text">請接續完成下一個步驟。</span>
                                </p>
                            </div>         
                        </div>
                    </b-container>
                </div>

                <!-- 步驟2 -->
                <div v-if="setp.market_crop.value != '-1'" class="w3-container w3-display-container w3-green py-4">
                    <b-container>
                        <!-- 標題 -->
                        <h5 class="title-sub">{{ setp2.title }}</h5>
                        <!-- 條件選單 -->
                        <div class="w3-row">
                            <!-- 種植日期 -->
                            <div class="w3-col w3-container m4 l3">
                                <p>
                                    <label style="color: #FFFFFF">{{ setp2.date.text }}</label>
                                    <input class="w3-input" type="date" v-model="setp2.date.value" :placeholder="setp2.date.placeholder">
                                </p>
                            </div>
                            <!-- 種植面積 -->
                            <div class="w3-col w3-container m4 l3">
                                <p>
                                    <label style="color: #FFFFFF">{{ setp2.area.text }}</label>
                                    <input class="w3-input" type="number" min="0" v-model="setp2.area.value" :placeholder="setp2.area.placeholder">
                                </p>
                            </div>
                            <!-- 預估產量 -->
                            <div class="w3-col w3-container m4 l3">
                                <p>
                                    <label style="color: #FFFFFF">{{ setp2.yield.text }}</label>
                                    <input class="w3-input" type="number" min="0" v-model="setp2.yield.value" :placeholder="setp2.yield.placeholder">
                                </p>
                            </div>
                            <!-- 提交 -->
                            <div class="w3-col w3-container m4 l3" v-if="setp.market_crop.value != '-1' && setp2.date.value !='' && setp2.area.value != '' && setp2.yield.value !=''">
                                <p>
                                    <i class="fas fa-check check"></i><span class="check-text">您已成功完成第二步驟。</span>
                                </p>
                                <p>
                                    <i class="fas fa-angle-double-down faa-bounce faa-reverse double-down"></i><span class="double-down-text">請接續完成下一個步驟。</span>
                                </p>
                            </div>
                        </div>
                    </b-container>
                </div>

                <!-- 步驟3 -->
                <div v-if="setp3.crops.length > 0" class="w3-container w3-display-container w3-brown py-4" id="setp3">
                    <b-container>
                        <!-- 標題 -->
                        <h5 class="title-sub">{{ setp3.title }}</h5>
                        <!-- 作物多選 -->
                        <div v-for="(value, key) in setp3.crops" :key="'type' + key">       
                            <div class="crop-name" >{{ key + 1 }} . {{ value.crop }}</div>
                            <div class="w3-row">
                                <div class="w3-col w3-container m4 l3" v-for="(value2,key2) in value.list" :key="'type' + key2">
                                    <p>
                                        <input class="w3-check" type="checkbox" v-model="setp3.checked" :value="value2.name">
                                        <label style="color: #FFFFFF">&nbsp; {{ value2.name }}</label>
                                    </p>
                                </div>
                            </div>
                            <hr v-if="key != setp3.crops.length-1" :key="'type' + key" />
                        </div>
                        <!-- 按鈕 -->
                        <div class="w3-row">
                            <!-- 試算替代結果 -->
                            <div class="w3-col w3-container m4 l4">
                                <p><button class="w3-button w3-block w3-indigo w3-round-large" v-if="setp3.crops.length > 0" @click="onSubmit">試算替代結果</button></p>
                            </div>
                            <!-- 重選替代作物 -->
                            <div class="w3-col w3-container m4 l4">
                                <p><button class="w3-button w3-block w3-blue-grey w3-round-large" v-if="setp3.crops.length > 0" @click="onClear">重選替代作物</button></p>
                            </div>
                            <!-- 清空所有選擇 -->
                            <div class="w3-col w3-container m4 l4">
                                <p><button class="w3-button w3-block w3-red w3-round-large" v-if="setp3.crops.length > 0" @click="onReset">清空所有選擇</button></p> 
                            </div>
                        </div> 
                    </b-container>
                </div>

                <!-- 彈出視窗 -->
                <div v-show="modal.calculation.show" class="w3-modal" style="display: block;">
                    <div class="w3-modal-content w3-round-large">
                        <div class="w3-container calculation">
                            <!-- 關閉按鈕 -->
                            <span class="w3-button w3-transparent w3-display-topright close-window-btn" @click="modal.calculation.show = false;"><span class="icon-cross"></span></span>
                            <!-- 標題 -->
                            <h3 class="modal-title">試算結果</h3>
                            <div class="w3-container">
                                預測分析及最適推薦，依收入排序 <span class="required">(預測結果僅供參考)</span>。
                                <p >資料來源網址：<a target="_blank" href="https://data.coa.gov.tw/open_detail.aspx?id=037">農業部農業資料開放平台</a></p>
                            </div>
                            <!-- 圖表 -->
                            <div id="charts"></div>
                            <!-- 生產管理注意事項 -->
                            <!--
                            <h3 class="modal-title" v-if="modal.calculation.suggest.length > 0">生產管理注意事項</h3> 
                            <div class="center-block" v-if="modal.calculation.suggest.length > 0">
                                <div class="table-responsive">
                                    <table class="w3-table-all table w3-medium">
                                        <tr>
                                            <th style="min-width: 100px;">作物</th>
                                            <th style="min-width: 120px;">生育期</th>
                                            <th style="min-width: 100px;">常見蟲害</th>
                                            <th>常見病害</th>
                                            <th>肥培管理</th>
                                        </tr>     
                                        <tr v-for="(value,key) in modal.calculation.suggest" :key="'type' + key" :style="getPeriodsStyle(value.periods)">
                                            <td>{{ value.name_crop }}</td>
                                            <td>{{ value.periods }}</td>
                                            <td>{{ value.pests }}</td>
                                            <td>{{ value.disease }}</td>
                                            <td>{{ value.fertilizer_management }}</td>
                                        </tr> 
                                    </table>
                                </div>
                            </div>
                            -->
                            <div v-if="modal.calculation.suggest.length > 0" class="w3-container w3-green"> 
                                生產管理注意事項
                            </div>
                            <table class="analyze-periods-table periods" v-for="(value, key) in modal.calculation.suggest" :key="'suggest' + key">
                                <tbody>
                                    <tr :style="getPeriodsStyle(value.periods)">
                                        <td class="field">作物</td>
                                        <td class="value">{{ value.name_crop }}</td>
                                    </tr>
                                    <tr :style="getPeriodsStyle(value.periods)">
                                        <td class="field">生育期</td>
                                        <td class="value">{{ value.periods }}</td>
                                    </tr>
                                    <tr :style="getPeriodsStyle(value.periods)">
                                        <td class="field">常見蟲害</td>
                                        <td class="value">{{ value.pests }}</td>
                                    </tr>
                                    <tr :style="getPeriodsStyle(value.periods)">
                                        <td class="field">常見病害</td>
                                        <td class="value">{{ value.disease }}</td>
                                    </tr>
                                    <tr :style="getPeriodsStyle(value.periods)">
                                        <td class="field">肥培管理</td>
                                        <td class="value">{{ value.fertilizer_management }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    
</template>
<script>

    export default {
        data() {
            return {

                //標題
                title:"農地智囊",

                //導覽列
                items: [
                    {
                        text: '首頁',
                        href: '#/'
                    },
                    {
                        text: '農地智囊',
                        active: true
                    }
                ],

                //步驟1
                setp:{

                    title:"第一步 選取自己正在種植的植物",
                    type:{
                        text:"我種的種類",
                        value:"-1",
                        placeholder:"請選擇種類",
                        list:[
                            {text:"花果菜類",value:"0"},
                            {text:"根莖菜類",value:"1"},
                            {text:"葉菜類",value:"2"},
                        ],
                    },
                    market_crop:{
                        text:"市場作物名稱",
                        value:"-1",
                        placeholder:"請選擇市場作物名稱",
                        list:[],
                        //選單的分群
                        group:[],
                    },
                },

                //步驟2
                setp2:{

                    title:"第二步 選取要種植的日期及填入種植面積",
                    date:{
                        text:"種植日期",
                        value:"",
                        placeholder:"請選擇種植日期",
                    },
                    area:{
                        text:"種植面積",
                        value:"",
                        placeholder:"請輸入種植面積",
                    },
                    yield:{
                        text:"預估產量",
                        value:"",
                        placeholder:"請輸入預估產量",
                    },
                },

                //步驟3
                setp3:{

                    //是否正在加載替代作物
                    is_load:false,
                    title:"第三步 選取替代作物 (可複選)",
                    //替代作物(全部)
                    crops:[],
                    //替代作物(已勾選)
                    checked:[],
                    //延遲執行
                    timeout_id:-1           
                },

                //彈出視窗
                modal:{           
                    //試算
                    calculation:{
                        //是否呈現
                        show:false,
                        //標題
                        title:"請選擇作物",
                        //生產管理建議
                        suggest:[],
                    }
                },

                //api 取得主產作物種類(步驟1-市場作物名稱)
                //apiGetMarketCrop: (data) => this.userRequest.post("/API/Default/GetMarketCrop", data),
                apiGetMarketCrop: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/api/FarmerService/CROP_DELIVERY_PERIOD_SORTSelect", data),                

                //api 取得該作物種植面積、預估產量(步驟2)
                //apiGetAgriSurvey: (data) => this.userRequest.post("/API/Default/GetAgriSurvey", data),
                apiGetAgriSurvey: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/Api/FarmerService/AGRI_SURVEYSelect", data),

                //api 取得該作物替代作物(步驟3)
                //apiGetSubstituteCrop: (data) => this.userRequest.post("/API/Default/GetSubstituteCrop", data),
                apiGetSubstituteCrop: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/api/agri/CropDeliveryPeriodSortGetAssistDecisionForSimple", data),

                //api 設定查詢參數農地智囊提交結果(彈出視窗)
                //apiSetUserRuralTempInfo: (data) => this.userRequest.post("/API/Default/SetUserRuralTempInfo", data),
                apiSetUserRuralTempInfo: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/api/agri/SetUserRuralTempInfo", data),

                //api 取得生產管理建議(彈出視窗)
                //apiGetCropProductionManagementSuggest: (data) => this.userRequest.post("/API/Default/GetCropProductionManagementSuggest", data),
                apiGetCropProductionManagementSuggest: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/Api/FarmerService/CROP_PRODUCTION_MANAGEMENT_SUGGESTSelect2", data),

                //api 取得農地智囊圖表資料(彈出視窗)
                //apiGetMarketPrediction: (data) => this.userRequest.post("/API/Default/GetMarketPrediction", data),
                apiGetMarketPrediction: (data) => this.userRequest.post("https://agri-data.kcg.gov.tw/Agri_API/api/agri/MarketPredictionSimplify", data),
            }
        },
        watch: {

            //第一步-我種的種類
            "setp.type.value":function(val){

                console.log(val);
                this.getMarketCrop();
            },

            //第一步-我種的種類(市場作物名稱)
            "setp.market_crop.value":function(val){

                console.log(val);
                this.getAgriSurvey();   
            },

            //第二步-種植日期
            "setp2.date.value":function(val){
            
                console.log(val);
                if(this.setp2.date.value != "" && this.setp2.area.value != "" && this.setp2.yield.value != "")
                {
                    this.getSubstituteCrop();
                }
            },

            //第二步-種植面積
            "setp2.area.value":function(val){
            
                if(val != "" && Number(val) > 0)
                {
                    if(this.setp.market_crop.rate_h != "" && Number(this.setp.market_crop.rate_h) > 0)
                    {
                        this.setp2.yield.value = Number(val) * Number(this.setp.market_crop.rate_h);
                        return false;   //為了不重複觸發 this.getSubstituteCrop(); 所以回傳 false
                    }
                }

                if(this.setp2.date.value != "" && this.setp2.area.value != "" && this.setp2.yield.value != "")
                {
                    this.getSubstituteCrop();
                }
            },

            //第二步-預估產量
            "setp2.yield.value":function(val){
            
                console.log(val);
                if(this.setp2.date.value != "" && this.setp2.area.value != "" && this.setp2.yield.value != "")
                {
                    this.getSubstituteCrop();
                }
            },

            //第三步-替代作物(勾選作物)
            "setp3.checked":function(val){

                console.log(val);
            },

        },
        mounted(){

            this.checkLogin();
        },
        created() {
            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);

            //順便補充，如果vue認不得外部定義的函式，可以藉由 window 變數
            //像是一般呼叫外部函式 是這樣 Browser.GetLocationRootUrl()
            //但在Vue要呼叫時，則是 window.Browser.GetLocationRootUrl()                  
        },
        destroyed() {

        },
        methods: {

            // 將數字轉換為千分位
            getTenPercentile: function(val)
            {
                //避免傳入的參數是數字(因為數字不支援replace)
                var temp = val + "";
                return temp.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            },

            //將字串轉成日期(yyyy-mm-dd)
            getFormatDate:function(str) 
            {
                return new Date(str);
            },

            //將日期轉成字串(yyyy-mm-dd)
            getFormatDateString:function(date) 
            {
                var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

                if (month.length < 2) 
                {
                    month = '0' + month;
                }
                    
                if (day.length < 2) 
                {
                    day = '0' + day;
                }
        
                return [year, month, day].join('-');
            },

            //日期增加天數(會直接改變當下的日期變數)
            addDay:function(date,day) { date.setDate(date.getDate() + day); },

            //取得主產作物種類(步驟1-市場作物名稱)
            getMarketCrop:function()
            {
                this.enableMask();
                this.setp.market_crop.value = "-1";
                this.setp.market_crop.list = [];
                this.setp.market_crop.group = [];

                this.setp.market_crop.rate_h = 0;
                this.setp.market_crop.area_h = 0;                

                this.setp2.date.value = "";
                this.setp2.area.value = "";
                this.setp2.yield.value = "";

                this.setp3.crops = [];
                this.setp3.checked = [];

                if(this.setp.type.value > -1){

                    this.apiGetMarketCrop({

                        TYPE_ATTRIBUTES:this.setp.type.list[this.setp.type.value].text,     //"花果菜類"
                    })
                    .then((res)=>{
 
                        //const data = JSON.parse(res.data);
                        //如果直接抓高雄的資料，則無需轉成json
                        const data = res.data;
                        const list = data.menu;

                        var group_name = [];

                        for(var i=0 ; i<list.length ; i++)
                        {
                            //當日交易行情-選單-種類(只加入 草本、一次性採收)
                            if(list[i].TYPE_SPECIES == "草本" && list[i].HARVEST == "A")
                            {
                                var name = list[i].NAME_CROP;
                                if(group_name.indexOf(name) == -1)
                                {
                                    group_name.push(name);
                                    this.setp.market_crop.group.push({});
                                    this.setp.market_crop.group[this.setp.market_crop.group.length-1].label = name;
                                    this.setp.market_crop.group[this.setp.market_crop.group.length-1].list = [];
                                    this.setp.market_crop.group[this.setp.market_crop.group.length-1].list.push(
                                        {
                                            value:this.setp.market_crop.list.length,
                                            text:list[i].NAME_MARKET_CROP,                                  //"花椰菜-白梗"                              
                                            NAME_ALIAS:list[i].NAME_ALIAS,                                  //"花椰菜"
                                            NAME_CROP:list[i].NAME_CROP,                                    //"花椰菜"
                                            NAME_MARKET:list[i].NAME_MARKET,                                //"花椰菜"
                                            NAME_MARKET_CROP:list[i].NAME_MARKET_CROP,                      //"花椰菜-白梗"
                                            NAME_PRODUCT:list[i].NAME_PRODUCT,                              //"白梗"
                                            NAME_SURVEY:list[i].NAME_SURVEY,                                //"花椰菜（白花）"

                                            PERIODS_VEGETATIVE_GROWTH:list[i].PERIODS_VEGETATIVE_GROWTH,    //"45"
                                            PERIODS_MORIBANA:list[i].PERIODS_MORIBANA,                      //"15"
                                            PERIODS_FRUIT_DEVELOPMENT:list[i].PERIODS_FRUIT_DEVELOPMENT,    //"0"
                                            PERIODS_HARVEST:list[i].PERIODS_HARVEST,                        //"7"
                                            DAY_FERTILITY:list[i].DAY_FERTILITY,                            //"67"

                                        }
                                    ); 

                                }
                                else
                                {
                                    this.setp.market_crop.group[this.setp.market_crop.group.length-1].list.push(
                                        {
                                            value:this.setp.market_crop.list.length,
                                            text:list[i].NAME_MARKET_CROP,                                  //"花椰菜-白梗"                              
                                            NAME_ALIAS:list[i].NAME_ALIAS,                                  //"花椰菜"
                                            NAME_CROP:list[i].NAME_CROP,                                    //"花椰菜"
                                            NAME_MARKET:list[i].NAME_MARKET,                                //"花椰菜"
                                            NAME_MARKET_CROP:list[i].NAME_MARKET_CROP,                      //"花椰菜-白梗"
                                            NAME_PRODUCT:list[i].NAME_PRODUCT,                              //"白梗"
                                            NAME_SURVEY:list[i].NAME_SURVEY,                                //"花椰菜（白花）"

                                            PERIODS_VEGETATIVE_GROWTH:list[i].PERIODS_VEGETATIVE_GROWTH,    //"45"
                                            PERIODS_MORIBANA:list[i].PERIODS_MORIBANA,                      //"15"
                                            PERIODS_FRUIT_DEVELOPMENT:list[i].PERIODS_FRUIT_DEVELOPMENT,    //"0"
                                            PERIODS_HARVEST:list[i].PERIODS_HARVEST,                        //"7"
                                            DAY_FERTILITY:list[i].DAY_FERTILITY,                            //"67"

                                        }
                                    );  
                                }


                                this.setp.market_crop.list.push({
                                    value:this.setp.market_crop.list.length,
                                    text:list[i].NAME_MARKET_CROP,                                  //"花椰菜-白梗"                              
                                    NAME_ALIAS:list[i].NAME_ALIAS,                                  //"花椰菜"
                                    NAME_CROP:list[i].NAME_CROP,                                    //"花椰菜"
                                    NAME_MARKET:list[i].NAME_MARKET,                                //"花椰菜"
                                    NAME_MARKET_CROP:list[i].NAME_MARKET_CROP,                      //"花椰菜-白梗"
                                    NAME_PRODUCT:list[i].NAME_PRODUCT,                              //"白梗"
                                    NAME_SURVEY:list[i].NAME_SURVEY,                                //"花椰菜（白花）"

                                    PERIODS_VEGETATIVE_GROWTH:list[i].PERIODS_VEGETATIVE_GROWTH,    //"45"
                                    PERIODS_MORIBANA:list[i].PERIODS_MORIBANA,                      //"15"
                                    PERIODS_FRUIT_DEVELOPMENT:list[i].PERIODS_FRUIT_DEVELOPMENT,    //"0"
                                    PERIODS_HARVEST:list[i].PERIODS_HARVEST,                        //"7"
                                    DAY_FERTILITY:list[i].DAY_FERTILITY,                            //"67"

                                });

                            }

                        }
                        this.disableMask();
                    })
                    .catch((err)=> {
                        console.log(err);
                        this.disableMask();
                    });

                }else{
                    this.disableMask();
                }
            }, 

            //取得該作物種植面積、預估產量(步驟2)
            getAgriSurvey:function(){

                this.enableMask();

                this.setp.market_crop.rate_h = 0;
                this.setp.market_crop.area_h = 0;

                this.setp2.date.value = "";
                this.setp2.area.value = "";
                this.setp2.yield.value = "";

                this.setp3.crops = [];
                this.setp3.checked = [];

                if(this.setp.market_crop.value > -1){

                    this.apiGetAgriSurvey({

                        CROP:this.setp.market_crop.list[this.setp.market_crop.value].NAME_CROP, //"花椰菜"
                    })
                    .then((res)=>{

                        //const data = JSON.parse(res.data);
                        //如果直接抓高雄的資料，則無需轉成json
                        const data = res.data;
                        this.setp.market_crop.rate_h = Number(data.RATE_H);     //"18418"
                        this.setp.market_crop.area_h = Number(data.AREA_H);     //"0.06"
                        this.disableMask();
                    })
                    .catch((err)=> {
                        console.log(err);
                        this.disableMask();
                    });

                }else{
                    this.disableMask();
                }
            },

            //取得該作物替代作物(步驟3)
            getSubstituteCrop:function()
            {

                if(this.setp3.timeout_id != -1)
                {
                    //表示有延遲執行
                    //先清除目前延遲執行
                    window.clearTimeout(this.setp3.timeout_id);
                }
                
                this.setp3.timeout_id = window.setTimeout(function(){

                    window.vue.getSubstituteCropAction();
                    window.vue.setp3.timeout_id = -1;

                }, 2000);
            },
            //取得該作物替代作物(步驟3)
            getSubstituteCropAction:function(){

                if(this.setp3.is_load == false)
                {
                    this.setp3.is_load = true;

                    this.setp3.crops = [];
                    this.setp3.checked = [];
                    this.enableMask();

                    this.apiGetSubstituteCrop({

                        User_ID: "-1",
                        TOWN_ID: "",
                        TYPE_ATTRIBUTES: this.setp.type.list[this.setp.type.value].text,                            //"花果菜類"
                        DATE_PLANT: this.setp2.date.value,                                                          //"2023-09-08"
                        AREA_H: this.setp2.area.value,                                                              //"11"
                        WEIGHT_PRODUCE: this.setp2.yield.value,                                                     //202598
                        NAME_CROP: this.setp.market_crop.list[this.setp.market_crop.value].NAME_CROP,               //"花椰菜"
                        NAME_SURVEY: this.setp.market_crop.list[this.setp.market_crop.value].NAME_SURVEY,           //"花椰菜（白花）"
                        NAME_ALIAS: this.setp.market_crop.list[this.setp.market_crop.value].NAME_ALIAS,             //"花椰菜"
                        NAME_PRODUCT: this.setp.market_crop.list[this.setp.market_crop.value].NAME_PRODUCT,         //"白梗"
                        NAME_MARKET: this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET,           //"花椰菜"
                        NAME_MARKET_CROP: this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET_CROP, //"花椰菜-白梗"
                    })
                    .then((res)=>{

                        //const data = JSON.parse(res.data);
                        //如果直接抓高雄的資料，則無需轉成json
                        const data = res.data;
                        this.setp3.is_load = false;

                        if(data.menu.length > 0)
                        {
                            var memo = data.menu[0].memo;
                            if(memo == null){ memo = []; }
                            for(var i=0 ; i<memo.length ; i++)
                            {
                                var item = {};
                                item.area_h = memo[i].AREA_H;       //"0.07"
                                item.rate_h = memo[i].RATE_H;       //"14746"
                                item.crop = memo[i].CROP;           //"不結球白菜"
                                item.list = [];

                                for(var j=0 ; j<memo[i].V_NAME.length ; j++)
                                {
                                    var item_sub = {};
                                    item_sub.day_fertility = memo[i].V_NAME[j].DAY_FERTILITY;                           //"30"
                                    item_sub.periods_fruit_development = memo[i].V_NAME[j].PERIODS_FRUIT_DEVELOPMENT;   //"0"
                                    item_sub.periods_harvest = memo[i].V_NAME[j].PERIODS_HARVEST;                       //"2"
                                    item_sub.periods_moribana = memo[i].V_NAME[j].PERIODS_MORIBANA;                     //"0"
                                    item_sub.periods_vegetative_growth = memo[i].V_NAME[j].PERIODS_VEGETATIVE_GROWTH;   //"28"
                                    item_sub.name = memo[i].V_NAME[j].V_NAME;                                           //"小白菜-土白菜"
                                    item.list.push(item_sub);
                                }

                                this.setp3.crops.push(item);
                            }
                        }

                        this.disableMask();
                    })
                    .catch((err)=> {
                        console.log(err);
                        this.disableMask();
                    });


                }else{

                    //如果正在加載，就Pass不理會，避免重複觸發
                }

            },

            //取得已選取作物 (生產管理建議 會用到)
            getCheckedCrop:function(){

                var list = [];

                for(var i=0 ; i<this.setp3.crops.length ; i++)
                {
                    var state = false;
                    var crop = this.setp3.crops[i].crop;

                    for(var j=0 ; j<this.setp3.crops[i].list.length ; j++)
                    {
                        var name = this.setp3.crops[i].list[j].name;

                        for(var k=0 ; k<this.setp3.checked.length ; k++)
                        {
                            var checked = this.setp3.checked[k];
                            if(name == checked){ state = true; }
                        }
                    }

                    if(state){ list.push(crop); }
                }

                return list;

            },

            //取得生產管理建議(彈出視窗)
            getCropProductionManagementSuggest:function(){

                //this.enableMask();
                
                this.apiGetCropProductionManagementSuggest({

                    NAME_CROP: this.getCheckedCrop().toString(),    //"青花菜,甘藍"

                    //以下是寫入Log 所需要的欄位
                    TOKEN:sessionStorage.getItem("TokenID"),
                    TYPE_ATTRIBUTES:this.setp.type.list[this.setp.type.value].text,
                    CROP:this.setp.market_crop.list[this.setp.market_crop.value].NAME_CROP,
                    NAME_MARKET_CROP:this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET_CROP,
                    DATE_PLANT:this.setp2.date.value,
                    AREA_H:this.setp2.area.value,
                    WEIGHT_PRODUCE:this.setp2.yield.value,
                    NAME_MARKET_CROP_SUBSTITUTE:this.setp3.checked.toString(),

                })
                .then((res)=>{

                    //const data = JSON.parse(res.data);
                    //如果直接抓高雄的資料，則無需轉成json
                    const data = res.data;
                    var menu = data.menu;
                    this.modal.calculation.suggest = [];

                    if(menu != null)
                    {
                        for(var i=0 ; i<menu.length ; i++)
                        {
                            this.modal.calculation.suggest.push({

                                disease:menu[i].DISEASE,                                //"細菌性軟腐病、黑斑病、露菌病、黑腐病、根瘤病、黃葉病、猝倒病與根腐病、苗立枯病、菌核病、黑腳病、病毒病害、根瘤線蟲"
                                fertilizer_management:menu[i].FERTILIZER_MANAGEMENT,    //"包含小白菜、青江菜、芥藍、芥藍芽、油菜及小芥菜、菾菜、甘藍芽、莧菜、京都水菜、芝麻菜、青油菜、青松菜及塔菇菜等。堆肥5-20公噸/公頃配合各種短期葉菜類所需化學肥料為施用量。非設施栽培氮素150-250公斤/公頃、磷酐50-75公斤/公頃、氧化鉀100-150公斤/公頃，塑膠布防雨保溫之設施栽培化學肥料用量降低25-50%。基肥：堆肥、磷肥均100%、氮肥、鉀肥各50%。追肥：發芽後15-20天，氮肥、鉀肥各50%"
                                name_crop:menu[i].NAME_CROP,                            //"不結球白菜"
                                periods:menu[i].PERIODS,                                //"營養生長期"
                                pests:menu[i].PESTS,                                    //"小菜蛾、切根蟲、紋白蝶、蚜蟲類、番茄斑潛蠅、菜心螟、黃條葉蚤、銀葉粉蝨、擬尺蠖、薊馬類、青椿象、大菜螟、斜紋夜蛾、甜菜夜蛾、蔬菜跳蟲、猿葉蟲"
                                source:menu[i].SOURCE,                                  //"短期葉菜TGAP_2021版/作物病蟲害與肥培管理技術資料光碟"
                            });
                        }
                    }

                    //this.disableMask();
                })
                .catch((err)=> {
                    console.log(err);
                    this.disableMask();
                });

            },

            //取得生育期樣式
            getPeriodsStyle:function(periods){

                var style = "";
                switch(periods)
                {
                    case "營養生長期":
                        style = "background-color: rgb(214,236,214)";
                    break;
                    case "開花期":
                        style = "background-color: rgb(193,225,236)";
                    break;
                    case "結果期":
                        style = "background-color: rgb(242,220,213)";
                    break;
                    case "採收期":
                        style = "background-color: rgb(255,252,177)";
                    break;
                }
                return style;
            },

            //設定查詢參數農地智囊提交結果(彈出視窗)
            setUserRuralTempInfo:function(){

                this.apiSetUserRuralTempInfo({

                    User_ID: "-1",
                    TOWN_ID: "",

                    TYPE_ATTRIBUTES: this.setp.type.list[this.setp.type.value].text,                            //"花果菜類"
                    DATE_PLANT: this.setp2.date.value,                                                          //"2023-09-08"
                    AREA_H: this.setp2.area.value,                                                              //"11"
                    WEIGHT_PRODUCE: this.setp2.yield.value,                                                     //202598
                    NAME_CROP: this.setp.market_crop.list[this.setp.market_crop.value].NAME_CROP,               //"花椰菜"
                    NAME_SURVEY: this.setp.market_crop.list[this.setp.market_crop.value].NAME_SURVEY,           //"花椰菜（白花）"
                    NAME_ALIAS: this.setp.market_crop.list[this.setp.market_crop.value].NAME_ALIAS,             //"花椰菜"
                    NAME_PRODUCT: this.setp.market_crop.list[this.setp.market_crop.value].NAME_PRODUCT,         //"白梗"
                    NAME_MARKET: this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET,           //"花椰菜"
                    NAME_MARKET_CROP: this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET_CROP, //"花椰菜-白梗"

                })
                .then((res)=>{

                    console.log(res);
                    this.getCropProductionManagementSuggest();
                    this.getMarketPrediction();

                })
                .catch((err)=> {
                    console.log(err);
                });

            },

            //取得農地智囊圖表資料(彈出視窗)
            getMarketPrediction:function()
            {
                this.enableMask();

                var temp = [];

                for(var i=0 ; i<this.setp3.checked.length ; i++)
                {
                    temp.push(this.setp3.checked[i]);
                }

                temp.push(this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET_CROP);

                this.apiGetMarketPrediction({

                    CROPS: temp,
                    SN:-1
                })
                .then((res)=>{

                    //var data = JSON.parse(res.data);
                    //如果直接抓高雄的資料，則無需轉成json
                    const data = res.data;
                    document.getElementById('charts').innerHTML = '';

                    if(data.length > 0)
                    {
                        //暫存有市場資料(之後再用收入排序)
                        var chart_array = [];

                        for(var i=0 ; i<data.length ; i++)
                        {
                            var item = data[i];   
                            var name = item.name; 
                            var period = {};
                            var period_date = {};

                            //圖表Tag
                            const tag = "chart" + i; 
                            //各生育期的天數
                            period = this.getPeriods(name);
                            //採收期各日期的起訖日期(若陣列長度為0，表示沒有起訖時間，[0]為起、[1]為訖) 
                            period_date = this.getPeriodsDate(period);
                            //種植面積
                            var periods_area = 0;
                            //預估天數
                            var periods_day = 0;
                            //預估產量
                            var periods_produce = 0;
                            //預估採收期均價
                            var periods_harvest_avg = 0;
                            //預估可收入
                            var periods_harvest_income_estimate = 0;

                            var orignal = item.orignalprice;
                            var min = item.minprice;
                            var max = item.maxprice;

                            var range_x = 0;
                            var range_x2 = 0;
                            if(item.maxprice.length > 0)
                            {
                                range_x = item.maxprice[0].x;
                                range_x2 = item.maxprice[item.maxprice.length-1].x;
                            }

                            var orignal_arr = [];
                            var min_arr = [];
                            var max_arr = [];

                            var x = [];
                            var orignal_y = [];
                            var min_y = [];
                            var max_y = [];

                            var periods_vegetative_growth_y = [];
                            var periods_moribana_y = [];
                            var periods_fruit_development_y = [];
                            var periods_harvest_y = [];

                            var estimate_y = [];

                            for(var k=0 ; k<orignal.length ; k++)
                            {
                                var num = Number(orignal[k].y);
                                var rounded = Math.round((num + Number.EPSILON) * 100) / 100;
                                orignal_arr[orignal[k].x] = rounded; 
                            }

                            for(var l=0 ; l<min.length ; l++)
                            {
                                var num2 = Number(min[l].y);
                                var rounded2 = Math.round((num2 + Number.EPSILON) * 100) / 100;
                                min_arr[min[l].x] = rounded2; 
                            }

                            for(var m=0 ; m<max.length ; m++)
                            {
                                var num3 = Number(max[m].y);
                                var rounded3 = Math.round((num3 + Number.EPSILON) * 100) / 100;
                                max_arr[max[m].x] = rounded3; 
                            }

                            for(var j=0 ; j<orignal.length ; j++)
                            {
                                var orignal_num = Number(orignal[j].y);
                                var orignal_rounded = Math.round((orignal_num + Number.EPSILON) * 100) / 100;

                                //捨去價格為0的資料
                                if(orignal_rounded > 0)
                                {
                                    x.push(orignal[j].x);
                                    orignal_y.push(orignal_rounded);

                                    if(typeof(min_arr[orignal[j].x]) != "undefined")
                                    {
                                        min_y.push(min_arr[orignal[j].x]);
                                    }
                                    else
                                    {
                                        min_y.push(null);
                                    }

                                    if(typeof(max_arr[orignal[j].x]) != "undefined")
                                    {
                                        max_y.push(max_arr[orignal[j].x]);
                                    }
                                    else
                                    {
                                        max_y.push(null);
                                    }

                                    //營養生長期
                                    if(period_date.periods_vegetative_growth.length > 1)
                                    {
                                        if( period_date.periods_vegetative_growth[1] >= orignal[j].x &&
                                            period_date.periods_vegetative_growth[0] <= orignal[j].x){
                                            
                                            //紀錄:最後一個位置
                                            period_date.periods_vegetative_growth[2] = periods_vegetative_growth_y.length; 
                                            //紀錄:最後一個值 
                                            period_date.periods_vegetative_growth[3] = orignal_rounded;  

                                            periods_vegetative_growth_y.push(orignal_rounded);
                                        }
                                        else
                                        {
                                            periods_vegetative_growth_y.push(null);
                                        }
                                    }

                                    //盛花期(開花期)
                                    if(period_date.periods_moribana.length > 1)
                                    {
                                        if( period_date.periods_moribana[1] >= orignal[j].x &&
                                            period_date.periods_moribana[0] <= orignal[j].x){
                                                
                                            //紀錄:最後一個位置
                                            period_date.periods_moribana[2] = periods_moribana_y.length; 
                                            //紀錄:最後一個值 
                                            period_date.periods_moribana[3] = orignal_rounded; 

                                            periods_moribana_y.push(orignal_rounded);
                                        }
                                        else
                                        {
                                            periods_moribana_y.push(null);
                                        }
                                    }

                                    //果實發育期(結果期)	
                                    if(period_date.periods_fruit_development.length > 1)
                                    {
                                        if( period_date.periods_fruit_development[1] >= orignal[j].x &&
                                            period_date.periods_fruit_development[0] <= orignal[j].x){
                                                
                                            //紀錄:最後一個位置
                                            period_date.periods_fruit_development[2] = periods_fruit_development_y.length; 
                                            //紀錄:最後一個值 
                                            period_date.periods_fruit_development[3] = orignal_rounded; 

                                            periods_fruit_development_y.push(orignal_rounded);
                                        }
                                        else
                                        {
                                            periods_fruit_development_y.push(null);
                                        }
                                    }

                                    //採收期
                                    if(period_date.periods_harvest.length > 1)
                                    {
                                        if( period_date.periods_harvest[1] >= orignal[j].x &&
                                            period_date.periods_harvest[0] <= orignal[j].x){
                                     
                                            //紀錄:最後一個位置
                                            period_date.periods_harvest[2] = periods_harvest_y.length; 
                                            //紀錄:最後一個值 
                                            period_date.periods_harvest[3] = orignal_rounded; 

                                            periods_harvest_y.push(orignal_rounded);
                                        }
                                        else
                                        {
                                            periods_harvest_y.push(null);
                                        }
                                    }
                     
                                    //預估價格
                                    estimate_y.push(null);
                                
                                }else{

                                    //若起始的點剛好為0，那就必須找上一個生育期的最後的點來補(避免有斷點情形)

                                    //盛花期(開花期)
                                    if(period_date.periods_moribana.length > 1)
                                    {
                                        if( period_date.periods_moribana[0] == orignal[j].x)
                                        {
                                            if(period_date.periods_vegetative_growth.length > 1)
                                            {
                                                //營養生長期
                                                periods_moribana_y[period_date.periods_vegetative_growth[2]] = period_date.periods_vegetative_growth[3];
                                            }
                                        }
                                    }

                                    //果實發育期(結果期)
                                    if(period_date.periods_fruit_development.length > 1)
                                    {
                                        if( period_date.periods_fruit_development[0] == orignal[j].x)
                                        {
                                            if(period_date.periods_moribana.length > 1)
                                            {       
                                                //盛花期(開花期)
                                                periods_fruit_development_y[period_date.periods_moribana[2]] = period_date.periods_moribana[3];
                                            }
                                            else if(period_date.periods_vegetative_growth.length > 1)
                                            {
                                                //營養生長期
                                                periods_fruit_development_y[period_date.periods_vegetative_growth[2]] = period_date.periods_vegetative_growth[3];
                                            }

                                        }
                                    }
                                    
                                    //採收期
                                    if(period_date.periods_harvest.length > 1)
                                    {
                                        if( period_date.periods_harvest[0] == orignal[j].x)
                                        {
                                            if(period_date.periods_fruit_development.length > 1)
                                            {
                                                //果實發育期(結果期)	
                                                periods_harvest_y[period_date.periods_fruit_development[2]] = period_date.periods_fruit_development[3];
                                            }
                                            else if(period_date.periods_moribana.length > 1)
                                            {       
                                                //盛花期(開花期)
                                                periods_harvest_y[period_date.periods_moribana[2]] = period_date.periods_moribana[3];
                                            }
                                            else if(period_date.periods_vegetative_growth.length > 1)
                                            {
                                                //營養生長期
                                                periods_harvest_y[period_date.periods_vegetative_growth[2]] = period_date.periods_vegetative_growth[3];
                                            }
                                        }
                                    }

                                }

                            }

                            var colors = [];
                            var series = [];

                            //預估價格
                            if(item.maxprice.length > 0)
                            {
                                colors.push("#E0E0E0");
                                series.push({

                                    name: "預估價格",
                                    data: estimate_y
                                });
                            }

                            if(periods_vegetative_growth_y.length > 0){ 
                                colors.push("#1FF21F");
                                series.push({

                                    name: "營養生長期",
                                    data: periods_vegetative_growth_y
                                });
                            }

                            if(periods_moribana_y.length > 0){ 
                                colors.push("#1EB4E8");
                                series.push({

                                    name: "開花期",
                                    data: periods_moribana_y
                                });
                            }

                            if(periods_fruit_development_y.length > 0){ 
                                colors.push("#F56031");
                                series.push({

                                    name: "結果期",
                                    data: periods_fruit_development_y
                                });
                            }

                            if(periods_harvest_y.length > 0){ 
                                colors.push("#FFEB3B");
                                series.push({

                                    name: "採收期",
                                    data: periods_harvest_y
                                });
                            }

                            //種植面積
                            periods_area = this.setp2.area.value;
                            //預估產量
                            periods_produce = Number(this.getRateH(name));
                            //預估天數
                            periods_day = Number(this.getPeriodsDay(name));
                            //預估採收期均價
                            periods_harvest_avg = Number(this.getPeriodsHarvestAvgPrice(periods_harvest_y));
                            //預估可收入
                            periods_harvest_income_estimate = this.getIncomeEstimate(periods_harvest_y,name);

                            const options = {
                                colors: colors,
                                series: series,
                                chart: {
                                    height: 350,
                                    type: 'line',
                                    zoom: {
                                        enabled: false
                                    }
                                },
                                dataLabels: {
            
                                },
                                annotations: {
                                    xaxis: [{
                                        x: range_x,
                                        x2: range_x2,
                                        fillColor: '#E0E0E0',
                                        opacity: 0.4,
                                        label: {
                                            borderColor: '#FF4560',
                                            offsetX: 30,
                                            offsetY: 0,
                                            style: {
                                                color: '#fff',
                                                background: '#FF4560',
                                                fontSize: '12px',
                                            },
                                            text: '預測價格區間',
                                        }  
                                    }],
                                },							
                                stroke: {
                                    curve: 'straight'
                                },
                                title: {
                                    text: name,
                                    align: 'left'
                                },
                                grid: {
                                    row: {
                                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                        opacity: 0.5
                                    },
                                },
                                xaxis: {
                                    categories: x,
                                    tickAmount: 6,
                                    labels: {
                                        //關閉字體自動旋轉
                                        rotate: 0
                                        /* 備註:若格式化，預測價格區間會消失，暫時將他遮罩
                                        formatter: function(value) {
                                            var date = new Date(value);
                                            var month = date.getMonth() + 1;
                                            var day = date.getDate();
                                            if(month < 10)
                                            {
                                                month = "0" + month;
                                            }
                                            else
                                            {
                                                month = "" + month;
                                            }

                                            if(day < 10)
                                            {
                                                day = "0" + day;
                                            }
                                            else
                                            {
                                                day = "" + day;
                                            }

                                            return month + "-" + day;
                                        }
                                        */
                                    }
                                }
                            };

                            //沒有預測區間
                            if(!(item.maxprice.length > 0))
                            {
                                options.annotations.xaxis = [];
                            }

                            var chart_item = {

                                //作物名稱
                                name:name,
                                //圖表Tag
                                tag:tag,
                                //種植面積
                                periods_area:periods_area,
                                //預估產量
                                periods_produce:periods_produce,
                                //預估天數
                                periods_day:periods_day,
                                //預估採收期均價
                                periods_harvest_avg:periods_harvest_avg,
                                //預估可收入 = 預估產量 * 預估採收期均價
                                periods_harvest_income_estimate:periods_harvest_income_estimate,
                                
                                //圖表配置值
                                options:options
                            };
        
                            chart_array.push(chart_item);
                        }
                    
                        chart_array.sort((a, b) => {
                            //遞增
                            //return a.periods_harvest_income_estimate - b.periods_harvest_income_estimate;
                            //遞減
                            return b.periods_harvest_income_estimate - a.periods_harvest_income_estimate;
                        });

                        for(var i2=0 ; i2<chart_array.length ; i2++)
                        {
                            var item2 = chart_array[i2];
                            document.getElementById('charts').innerHTML += '<div class="w3-container w3-amber w3-round" style="padding-top: 10px;padding-bottom: 10px;">'+ (i2+1) + '. ' + item2.name + ' ， 種植面積 : ' + item2.periods_area + '公頃 ， 估算產量 : ' + this.getTenPercentile(item2.periods_produce) + '公斤 ，預估' + item2.periods_day + '天可以採收， 採收期均價估算 : ' + item2.periods_harvest_avg + ' 元/公斤 ； 收入估算約 ' + this.getTenPercentile(item2.periods_harvest_income_estimate) + ' 元。</div>';
                            document.getElementById('charts').innerHTML += '<div class="w3-row mostly-customized-scrollbar" style="overflow-x: auto; overflow-y: hidden;"><div style="min-width: 600px;" id="' + item2.tag + '"></div></div>';
                            
                            window.setTimeout(function(tag,options){
                                new window.ApexCharts(document.querySelector("#"+tag), options).render();
                            },1000,item2.tag,item2.options);
                            
                            this.modal.calculation.show = true;
                        }

                    }
                 
                    this.disableMask();
                })
                .catch((err)=> {
                    console.log(err);
                    this.disableMask();
                });

            },

            //取得預估產量 : xx,xxx公斤(農地智囊提交結果 會用到)
            getRateH(name)
            {
                var rate_h = "";

                //替代作物
                for(var i=0 ; i<this.setp3.crops.length ; i++)
                {
                    var item = this.setp3.crops[i];
                    for(var j=0 ; j<item.list.length ; j++)
                    {
                        var item_sub = item.list[j];
                        if(item_sub.name == name)
                        {
                            rate_h = item.rate_h * Number(this.setp2.area.value);
                        }
                    }
                }

                //已選作物(會不在替代作物的清單內，所以要個別處理)
                if(this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET_CROP == name)
                {
                    rate_h = Number(this.setp2.yield.value);
                }

                return rate_h;
            },

            //取得生育期日數
            getPeriods(name)
            {
                var periods = {};

                //替代作物
                for(var i=0 ; i<this.setp3.crops.length ; i++)
                {
                    var item = this.setp3.crops[i];
                    for(var j=0 ; j<item.list.length ; j++)
                    {
                        var item_sub = item.list[j];
                        if(item_sub.name == name)
                        {
                            periods = 
                            {
                                day_fertility:Number(item_sub.day_fertility),
                                periods_fruit_development:Number(item_sub.periods_fruit_development),
                                periods_harvest:Number(item_sub.periods_harvest),
                                periods_moribana:Number(item_sub.periods_moribana),
                                periods_vegetative_growth:Number(item_sub.periods_vegetative_growth),
                            };
                            
                        }
                    }
                }

                //已選作物(會不在替代作物的清單內，所以要個別處理)
                if(this.setp.market_crop.list[this.setp.market_crop.value].NAME_MARKET_CROP == name)
                {
                    periods = 
                    {
                        day_fertility:Number(this.setp.market_crop.list[this.setp.market_crop.value].DAY_FERTILITY),
                        periods_fruit_development:Number(this.setp.market_crop.list[this.setp.market_crop.value].PERIODS_FRUIT_DEVELOPMENT),
                        periods_harvest:Number(this.setp.market_crop.list[this.setp.market_crop.value].PERIODS_HARVEST),
                        periods_moribana:Number(this.setp.market_crop.list[this.setp.market_crop.value].PERIODS_MORIBANA),
                        periods_vegetative_growth:Number(this.setp.market_crop.list[this.setp.market_crop.value].PERIODS_VEGETATIVE_GROWTH),
                    };                
                }

                return periods;
            },

            //取得預估xx天可以採收(農地智囊提交結果 會用到)
            getPeriodsDay(name)
            {
                var periods = this.getPeriods(name);
                var periods_day = periods.periods_vegetative_growth + periods.periods_moribana;
                return periods_day;
            },

            //取得生育期間
            getPeriodsDate(periods)
            {
                var periods_date = {};
                var date_temp = this.getFormatDate(this.setp2.date.value);
                //營養生長期
                periods_date.periods_vegetative_growth = [];
                if(periods.periods_vegetative_growth > 0)
                {
                    periods_date.periods_vegetative_growth[0] = this.getFormatDateString(date_temp);
                    this.addDay(date_temp,periods.periods_vegetative_growth);
                    periods_date.periods_vegetative_growth[1] = this.getFormatDateString(date_temp);

                    console.log("營養生長期");
                    console.log(periods_date.periods_vegetative_growth[0] + " - " + periods_date.periods_vegetative_growth[1]);
                }
                else
                {
                    periods_date.periods_vegetative_growth = [0];
                }

                //盛花期(開花期)
                periods_date.periods_moribana = [];
                if(periods.periods_moribana > 0)
                {
                    periods_date.periods_moribana[0] = this.getFormatDateString(date_temp);
                    this.addDay(date_temp,periods.periods_moribana);
                    periods_date.periods_moribana[1] = this.getFormatDateString(date_temp);
                }
                else
                {
                    periods_date.periods_moribana = [0];
                }

                //果實發育期(結果期)
                periods_date.periods_fruit_development = [];
                if(periods.periods_fruit_development > 0)
                {
                    periods_date.periods_fruit_development[0] = this.getFormatDateString(date_temp);
                    this.addDay(date_temp,periods.periods_fruit_development);
                    periods_date.periods_fruit_development[1] = this.getFormatDateString(date_temp);
                }
                else
                {
                    periods_date.periods_fruit_development = [0];
                }

                //採收期
                periods_date.periods_harvest = [];
                if(periods.periods_harvest > 0)
                {
                    periods_date.periods_harvest[0] = this.getFormatDateString(date_temp);
                    this.addDay(date_temp,periods.periods_harvest);
                    periods_date.periods_harvest[1] = this.getFormatDateString(date_temp);

                    console.log("採收期");
                    console.log(periods_date.periods_harvest[0] + " - " + periods_date.periods_harvest[1]);
                }
                else
                {
                    periods_date.periods_harvest = [0];
                }            

                return periods_date;
            },

            //預估採收期均價
            getPeriodsHarvestAvgPrice(arr)
            {
                var sum = 0;
                var count = 0;
                var avg = 0;
                for(var i=0 ; i<arr.length ; i++)
                {
                    if(arr[i] != null)
                    {
                        sum += arr[i];
                        count += 1;
                    }
                }

                if(count > 0)
                {
                    avg = sum / count;
                }

                return Number(avg).toFixed(2);
            },

            //預估可收入
            getIncomeEstimate(arr,name)
            {
                return parseInt(Number(this.getPeriodsHarvestAvgPrice(arr)) * Number(this.getRateH(name)));
            },

            //試算替代結果
            onSubmit:function()
            {
                //alert("試算替代結果");
           
                if(this.setp.type.value == "-1"){ alert("請於第一步驟，選擇我種的種類"); return false;}
                if(this.setp.market_crop.value == "-1"){ alert("請於第一步驟，選擇市場作物名稱"); return false;}

                if(this.setp2.date.value == ""){ alert("請於第二步驟，選擇種植日期"); return false;}
                if(this.setp2.area.value == ""){ alert("請於第二步驟，輸入種植面積"); return false;}
                if(this.setp2.yield.value == ""){ alert("請於第二步驟，輸入預估產量"); return false;}

                if(this.setp3.checked.length == 0){ alert("請於第三步驟，選擇替代作物(至少要選一個)"); return false;}
                
                //先將視窗相關內容清除
                document.getElementById('charts').innerHTML = '';
                this.modal.calculation.suggest = [];
                //先將視窗相關內容清除

                this.setUserRuralTempInfo();
            },

            //重選替代作物
            onClear:function()
            {
                //alert("重製所有選取條件");
   
                this.setp3.checked = [];
                window.scroll(0,document.getElementById('setp3').offsetTop);
 
            },

            //重製所有選取條件
            onReset:function()
            {
                //alert("重製所有選取條件");

                this.setp.type.value = "-1";

                this.setp.market_crop.value = "-1";
                this.setp.market_crop.list = [];

                this.setp.market_crop.rate_h = 0;
                this.setp.market_crop.area_h = 0;                

                this.setp2.date.value = "";
                this.setp2.area.value = "";
                this.setp2.yield.value = "";

                this.setp3.crops = [];
                this.setp3.checked = [];

                window.scroll(0,0);

            },


        },
    }

</script>
<style scoped>

    /** 欄位 */
    .field{
      font-size: 14px;
      font-weight: bold;
    }

    /** 值 */
    .value{
      font-size: 14px;
    }

    /** 必填欄位 */
    .required{
        color: #FF0000 !important;
    }

    /** 主體內容 */
    .w3-container {
        font-size: 14px;
        padding-top: 10px !important;
        padding-bottom: 10px !important;
    }

    /** 表格 */
    table{
        width: 100%;
    }

    /** 表格元素 */
    tbody th, tbody td {
        padding: 0.5rem 0.625rem 0.625rem;
    }

    /** 生產管理注意事項 */
    .analyze-periods-table {

        font-size: 14px;
    }
    .analyze-periods-table .field{

      width:80px; 
      vertical-align: top;
      text-align: right;
    }
    .analyze-periods-table .vlaue{

      vertical-align: top;
      text-align: left;
    }

    /** 主要頁面 */

    /** 替代作物勾選部分 */
    .check {

        color:#FFFFFF;
        width: 24px;
        font-size: 24px;
    }
    .check-text {

        color:#FFFFFF;
    }

    /** 步驟提示訊息(雙向下圖示) */
    .double-down{

        color:#FFFFFF;
        width: 24px;
        font-size: 24px;
    }
    .double-down-text {

        color:#FFFFFF;
    }

    /** 彈出視窗 */
    .calculation{
        padding: 15px;  
    }


    /** 表格卷軸 */
    .fix-width {
        width: 100%;
        overflow-y: hidden;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .table {
        min-width: 1200px;
        margin-bottom: 0;
        max-width: none;
    }

    .table-crop-field {
        width: 125px;
        text-align: end;
    }

    .table-crop-value {
        text-align: start;
    }

    /** 步驟3，作物標題 */
    .crop-name {

        font-size: 20px;
        font-weight: bolder;
        margin-bottom: 15px;
    }

    .visible-scrollbar,
    .invisible-scrollbar,
    .mostly-customized-scrollbar {
        display: block;
        width: 10em;
        overflow: auto;
        height: 2em;
    }

    .invisible-scrollbar::-webkit-scrollbar {
        display: none;
    }

    /* Demonstrate a "mostly customized" scrollbar
    * (won't be visible otherwise if width/height is specified) */
    .mostly-customized-scrollbar::-webkit-scrollbar {
        width: 5px;
        height: 8px;
        background-color: #aaa; /* or add it to the track */
    }

    /* Add a thumb */
    .mostly-customized-scrollbar::-webkit-scrollbar-thumb {
        background: #000;
    }
</style>